import { Trans } from '@lingui/macro';
import { Box, Container, Typography, useMediaQuery, useTheme } from '@mui/material';
import * as React from 'react';

import { FormattedNumber } from '../../components/primitives/FormattedNumber';
import { TopInfoPanelItem } from '../../components/TopInfoPanel/TopInfoPanelItem';
import { useAppDataContext } from '../../hooks/app-data-provider/useAppDataProvider';
import { valueToBigNumber } from 'packages/math-utils/dist/esm';

export const MarketTopPanel = () => {
  const { reserves, loading } = useAppDataContext();
  const theme = useTheme();
  const downToSM = useMediaQuery(theme.breakpoints.down('sm'));

  const valueTypographyVariant = downToSM ? 'main16' : 'main21';
  const noDataTypographyVariant = downToSM ? 'secondary16' : 'secondary21';

  const aggregatedStats = reserves.reduce(
    (acc, reserve) => {
      return {
        totalLiquidity: acc.totalLiquidity.plus(reserve.totalLiquidityUSD),
        totalDebt: acc.totalDebt.plus(reserve.totalDebtUSD),
      };
    },
    {
      totalLiquidity: valueToBigNumber(0),
      totalDebt: valueToBigNumber(0),
    }
  );

  return (
    <Box
      sx={{
        pt: { xs: 8, md: 12 },
        pb: { xs: 4, md: 8 },
      }}
    >
      <Container sx={{ pb: 0 }}>
        <Box sx={{ px: 0 }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '28px', md: '32px' }
            }}
          >
            Market
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 8,
              flexWrap: 'wrap',
              width: '100%',
              mt: 4,
            }}
          >
            <TopInfoPanelItem title={<Trans>Total market size</Trans>} loading={loading} hideIcon>
              <FormattedNumber
                  value={aggregatedStats.totalLiquidity.toString()}
                  symbol="USD"
                  variant={valueTypographyVariant}
                  visibleDecimals={2}
                  compact
                  symbolsColor="#A5A8B6"
                  symbolsVariant={noDataTypographyVariant}
              />
            </TopInfoPanelItem>
            <TopInfoPanelItem title={<Trans>Total available</Trans>} loading={loading} hideIcon>
              <FormattedNumber
                  value={aggregatedStats.totalLiquidity.minus(aggregatedStats.totalDebt).toString()}
                  symbol="USD"
                  variant={valueTypographyVariant}
                  visibleDecimals={2}
                  compact
                  symbolsColor="#A5A8B6"
                  symbolsVariant={noDataTypographyVariant}
              />
            </TopInfoPanelItem>
            <TopInfoPanelItem title={<Trans>Total borrowed</Trans>} loading={loading} hideIcon>
              <FormattedNumber
                  value={aggregatedStats.totalDebt.toString()}
                  symbol="USD"
                  variant={valueTypographyVariant}
                  visibleDecimals={2}
                  compact
                  symbolsColor="#A5A8B6"
                  symbolsVariant={noDataTypographyVariant}
              />
            </TopInfoPanelItem>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
